import { PressReleasesList } from "@app/modules/press-releases/components";
import { URLS } from "@app/shared";
import breadcrumbBg from "@assets/images/releases-breadcrumb.png";
import { PageHeader } from "@design-system/components";
import { trans } from "@mongez/localization";
import { PressRelease } from "../type";

export function PressReleasesPage({ news }: { news: PressRelease[] }) {
  return (
    <>
      <PageHeader
        image={breadcrumbBg}
        breadcrumbItems={[
          {
            label: "home",
            link: URLS.home,
          },
          {
            label: "pressReleases",
            link: URLS.pressReleases.root,
          },
        ]}
        contentClassName="!max-w-full"
        translationKey="pressReleases"
        className="max-lg:pb-12"
      >
        <h3 className="text-2xl font-medium leading-[1.2] text-white sm:text-3xl lg:text-4xl xl:w-[60%] xl:text-6xl">
          {trans("companyNewsAndPressReleases")}
        </h3>
      </PageHeader>
      <PressReleasesList news={news} />
      {/* <div className="h-[50px] bg-gradient-to-b from-primary to-marine lg:h-[100px]"></div> */}
    </>
  );
}
